var _path, _g, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlog = function SvgBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 45"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Blog_svg__a",
    width: 45,
    height: 45,
    x: 3,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 0h45v45H3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Blog_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m8.492 26.684-4.806-13.36a.454.454 0 0 1 .273-.576c2.543-.914 5.196-1.807 7.875-2.708m25.49 26.112-15.355 5.52-6.738 2.422a.45.45 0 0 1-.576-.27l-5.152-14.33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "m40.36 35.631-15.945 2.734-7.06 1.211a.456.456 0 0 1-.52-.368L14.23 24.003l-2.87-16.74a.451.451 0 0 1 .365-.52l8.045-1.38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m40.36 35.631-15.945 2.734-7.06 1.211a.456.456 0 0 1-.52-.368L14.23 24.003l-2.87-16.74a.451.451 0 0 1 .365-.52l8.045-1.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "M19.77 19.067V1.346c0-.258.21-.468.468-.468h21.279c.143 0 .183.058.426.288l5.134 4.896c.208.202.265.225.265.36V35.16c0 .258-.21.47-.468.47H20.238a.471.471 0 0 1-.468-.47V22.125"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M19.77 19.067V1.346c0-.258.21-.468.468-.468h21.279c.143 0 .183.058.426.288l5.134 4.896c.208.202.265.225.265.36V35.16c0 .258-.21.47-.468.47H20.238a.471.471 0 0 1-.468-.47V22.125"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m41.168.879.01 4.643c0 1.038.951.973 1.41.973h4.755M43.112 10.455H24.266M43.112 15.139H24.266M43.112 19.82H24.266M43.112 24.504H24.266M43.112 29.188H24.266"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Blog_svg__b)",
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M2.07 40.93a3.655 3.655 0 0 1 0-5.17l14.744-14.743 6.55-1.384-1.381 6.553L7.239 40.93a3.655 3.655 0 0 1-5.168 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m4.512 33.318 5.169 5.17"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blog_svg__b",
    x1: 23,
    x2: 1.003,
    y1: 20,
    y2: 41.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
};
export default SvgBlog;